import React, { createRef, FunctionComponent, useLayoutEffect } from "react";
import "./style.scss";
import time_tracking_img from "../../asserts/svg/time_tracking.svg";
import window_img from "../../asserts/svg/window.svg";
import scheduler_img from "../../asserts/svg/scheduler.svg";
import notification_img from "../../asserts/svg/notification.svg";
import list_img from "../../asserts/svg/list.svg";
import language_img from "../../asserts/svg/language.svg";
import code_img from "../../asserts/svg/code.svg";
import card_img from "../../asserts/svg/card.svg";
import calendar_img from "../../asserts/svg/calendar.svg";
import { NavLink } from "react-router-dom";

const FeaturesBlock: FunctionComponent = () => {
    const ref_text = createRef<HTMLDivElement>();
    const ref_border = createRef<HTMLDivElement>();

    useLayoutEffect(() => {
        window.addEventListener("resize", resize);
        setTimeout(() => {resize()}, 100);
        setTimeout(() => {resize()}, 1000);

        return () => {window.removeEventListener("resize", resize)}
    });

    const resize = () => {
        if (ref_border.current && ref_text.current) {
            ref_border.current.style.width = `${ref_text.current.clientWidth + 6}px`;
            ref_border.current.style.height = `${ref_text.current.clientHeight + 6}px`;
            ref_border.current.style.left = `calc(50% - ${ref_text.current.clientWidth / 2 - 4}px)`;
        }
    }

    return <div id="features" className="FeaturesBlock">
        <div className="content">
            <h1>Features</h1>
            <h4>Timinator can do many things for you but most of all it’s UNOBTRUSIVE. Wanna know more? Just read below!</h4>
            <div className="tiles">
                <div className="tile">
                    <div className="icon">
                        <img src={time_tracking_img} alt="time tracking" />
                    </div>
                    <div className="textContent">
                        <h3>Time tracking</h3>
                        <ul>
                            <li>Working hours</li>
                            <li>Absence hours</li>
                            <li>Overtime hours</li>
                            <li>Comfy editing</li>
                            <li>Shortcuts</li>
                        </ul>
                    </div>
                </div>

                <div className="tile">
                    <div className="icon">
                        <img src={window_img} alt="admin console" />
                    </div>
                    <div className="textContent">
                        <h3>Admin console</h3>
                        <ul className="mt">
                            <li>Clients</li>
                            <li>Projects</li>
                            <li>Employees</li>
                            <li>Roles</li>
                            <li>Project types</li>
                            <li>Shift types</li>
                            <li>Absence types</li>
                        </ul>
                    </div>
                </div>

                <div className="tile">
                    <div className="icon">
                        <img src={scheduler_img} alt="recurrent shifts" />
                    </div>
                    <div className="textContent">
                        <h3>Recurrent shifts</h3>
                        <div className="text">Trust your employees as we do? That will be your main feature to make everyone’s life WAY easier. Make scheduled shifts to track only exceptions like sick days or vacations.</div>
                    </div>
                </div>

                <div className="tile">
                    <div className="icon">
                        <img src={notification_img} alt="configurable reminders" />
                    </div>
                    <div className="textContent">
                        <h3>Configurable reminders</h3>
                        <div className="text">Specify the time when you want reminders to come.</div>
                    </div>
                </div>

                <div className="tile">
                    <div className="icon">
                        <img src={list_img} alt="reports" />
                    </div>
                    <div className="textContent">
                        <h3>Reports</h3>
                        <ul className="mt">
                            <li>By Employee</li>
                            <li>By Project</li>
                            <li>Detailed by day</li>
                            <li>File export</li>
                        </ul>
                    </div>
                </div>

                <div className="tile">
                    <div className="icon">
                        <img src={language_img} alt="vacations" />
                    </div>
                    <div className="textContent">
                        <h3>Vacations</h3>
                        <ul className="mt">
                            <li>Request</li>
                            <li>Approve by PM</li>
                            <li>Notify the team or everyone</li>
                            <li>Report</li>
                        </ul>
                    </div>
                </div>

                <div className="tile">
                    <div className="icon">
                        <img src={code_img} alt="integrations" />
                    </div>
                    <div className="textContent">
                        <h3>Integrations</h3>
                        <div className="text">Zoho invoice integration is onboard.</div>
                    </div>
                </div>

                <div className="tile">
                    <div className="icon">
                        <img src={calendar_img} alt="payments" />
                    </div>
                    <div className="textContent">
                        <h3>Working calendars</h3>
                        <div className="text">Automate public holiday tracking with calendar integration. Customize and assign individual calendars to team members.</div>
                    </div>
                </div>
            </div>

            <div className="buttons">
                <NavLink to="/features">
                    <button>
                        <div className="image"/>
                        <div className="text">Read more about Features</div>
                        <div className="text mobile">Read more</div>
                    </button>
                </NavLink>
            </div>

            <div className="bottomText">
                <div ref={ref_text} className="bottomContent">
                    <div className="text">
                        Everything is right in your messenger including the admin console and reports
                    </div>
                </div>
                <div ref={ref_border} className="border" />
            </div>
        </div>
    </div>
}

export default FeaturesBlock;